import { render, staticRenderFns } from "./DealCustomerRequestsPanel.vue?vue&type=template&id=ba34784e&scoped=true"
import script from "./DealCustomerRequestsPanel.vue?vue&type=script&lang=js"
export * from "./DealCustomerRequestsPanel.vue?vue&type=script&lang=js"
import style0 from "./DealCustomerRequestsPanel.vue?vue&type=style&index=0&id=ba34784e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba34784e",
  null
  
)

export default component.exports